module.exports = __webpack_public_path__ + "pdf-ffbc95ada40867d6da8a11ca5e50fa6e.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/file-formats/pdf.svg
// module id = 45
// module chunks = 0